/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AdminThreadsControllerFindAllQueryResponse, AdminThreadsControllerFindAllQueryParams } from "../../models/adminThreadsController/AdminThreadsControllerFindAll";

function getAdminThreadsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/admin/threads` as const }  
  return res
}

/**
 * @summary List a user’s Project Assist threads for customer debugging
 * {@link /api/v1/admin/threads}
 */
export async function adminThreadsControllerFindAll(params: AdminThreadsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AdminThreadsControllerFindAllQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAdminThreadsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}